import { ERD, SshAccountActions } from "@dots-crm/contracts/client";
import { api } from "api";
import { QueryArgsNew } from "api/api.type";
import {
  SSH_ACCOUNT_ENDPOINTS_URLS,
  SSH_ACCOUNT_TAGS,
} from "./api-ssh-account.constant";

export const {
  useCreateSshAccountMutation,
  useReadManySshAccountsQuery,
  useDeleteSshAccountMutation,
  useImportSshAccountsMutation,
} = api.injectEndpoints({
  endpoints: (builder) => ({
    createSshAccount: builder.mutation<
      ERD<SshAccountActions["create"]>,
      QueryArgsNew<SshAccountActions["create"]>
    >({
      query: ({ payload }) => ({
        url: SSH_ACCOUNT_ENDPOINTS_URLS.create,
        method: "post",
        payload,
      }),
      invalidatesTags: [SSH_ACCOUNT_TAGS.sshAccount],
    }),
    readManySshAccounts: builder.query<
      ERD<SshAccountActions["readMany"]>,
      QueryArgsNew<SshAccountActions["readMany"]>
    >({
      query: ({ query }) => ({
        url: SSH_ACCOUNT_ENDPOINTS_URLS.readMany,
        method: "get",
        query,
      }),
      providesTags: [SSH_ACCOUNT_TAGS.sshAccount],
    }),
    deleteSshAccount: builder.mutation<
      void,
      QueryArgsNew<SshAccountActions["delete"]>
    >({
      query: ({ params }) => ({
        url: SSH_ACCOUNT_ENDPOINTS_URLS.delete(params),
        method: "delete",
      }),
      invalidatesTags: [SSH_ACCOUNT_TAGS.sshAccount],
    }),
    importSshAccounts: builder.mutation<
      ERD<SshAccountActions["import"]>,
      { file: File }
    >({
      query: ({ file }) => {
        const formData = new FormData();
        formData.append("file", file);
        return {
          url: SSH_ACCOUNT_ENDPOINTS_URLS.import,
          method: "post",
          body: formData,
        };
      },
      invalidatesTags: [SSH_ACCOUNT_TAGS.sshAccount],
    }),
  }),
});

export const downloadSshAccountTemplate = async () => {
  const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:6002";
  const accessToken = localStorage.getItem("token");
  const response = await fetch(
    `${apiUrl}/${SSH_ACCOUNT_ENDPOINTS_URLS.importTemplate}`,
    { headers: { Authorization: accessToken || "" } }
  );
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "ssh-accounts-template.xlsx";
  link.click();
  window.URL.revokeObjectURL(url);
};

export const downloadSshAccountsExport = async () => {
  const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:6002";
  const accessToken = localStorage.getItem("token");
  const response = await fetch(
    `${apiUrl}/${SSH_ACCOUNT_ENDPOINTS_URLS.export}`,
    { headers: { Authorization: accessToken || "" } }
  );
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "ssh-accounts.xlsx";
  link.click();
  window.URL.revokeObjectURL(url);
};
